var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import HeaderItem from "../../components/HeaderItem.vue";
import { Component } from 'vue-property-decorator';
import PriceSettingService from '../../api/PriceSettingService';
import CommonService from '../../api/CommonService';
import GlobalVue from "../../globalVue";
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from 'element-ui';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.detail = {};
        _this.tableHeight = document.documentElement.clientHeight - 390;
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = PriceSettingService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    default_1.prototype.confirm = function () {
        var _this = this;
        this.$confirm("确认后将不可修改，是否继续？").then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.confirm(_this.rowId).then(function (result) {
                loadingInstance.close();
                if (result.data.code == 76) {
                    _this.$message.error(result.data.msg);
                    _this.getDetail();
                }
                else {
                    _this.$message.success(result.data.msg || "确认成功");
                    GlobalVue.$emit('closeTab', _this);
                    if (_this.opener && _this.opener.getList) {
                        _this.opener.getList();
                    }
                    window._czc.push(["_trackEvent", '定价单确认', '定价单确认']);
                }
            }, function (err) {
                if (err.resData.flag == 1) {
                    _this.$confirm(err.resData.msg).then(function (result) {
                        _this.service.delete(err.resData.data.business_id).then(function (result) {
                            loadingInstance.close();
                            GlobalVue.$emit('closeTab', _this);
                            if (_this.opener && _this.opener.getList) {
                                _this.opener.getList();
                            }
                        }).catch(function (delErr) {
                            loadingInstance.close();
                            _this.$message.error(delErr.msg || delErr.message);
                        });
                    });
                }
                else {
                    loadingInstance.close();
                    _this.$message.error(err.resData.msg || "确认失败");
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) {
        });
    };
    default_1.prototype.mounted = function () {
        this.getDetail();
        this.getGoodsTypeList();
    };
    default_1.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    default_1.prototype.search = function () {
        console.log(11111111, this.goodsFormData);
        this.$refs.pagination.clear();
        this.getDetail();
    };
    default_1.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.pageChange = function (pager) {
        this.getDetail();
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        Object.assign(params, { start: pager.start, limit: pager.limit });
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.detail(params).then(function (res) {
            loadingInstance.close();
            _this.detail = res.data.data;
            _this.detail.shops = _this.detail.shop_list ? _this.detail.shop_list.join(",") : "";
            _this.data = res.data.data.order_detail || [];
            _this.total = res.data.total || 0;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.toAccount = function () {
        toDetail(EBillType.Quote, this.detail.quotation_order_id);
    };
    default_1 = __decorate([
        auth(nameDict["定价"]),
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
